import { Empty, List, PullRefresh, Search } from "vant"
import { computed, defineComponent, onMounted, reactive, ref, watch } from "vue"
import styles from "./index.module.less"

export default defineComponent({
  name: "MobileList",
  props: {
    refresh: Boolean, // 是否开启下拉刷新操作
    paging: Boolean, // 是否开启分页操作
    useSearch: Boolean, // 是否使用搜索栏
    getList: Function,
    refreshConfig: Object,
    listConfig: Object,
    searchConfig: Object,
    loading: { type: Boolean, default: false }
  },
  emits: ["update:loading", "loaded"],
  setup(props, { slots, expose, emit }) {
    const loading = ref(false)

    watch(loading, (v) => {
      emit("update:loading", v)
    })

    const listConfig = computed(() => {
      return {
        finishedText: "没有更多了",
        emptyText: "暂无数据",
        ...props.listConfig
      }
    })

    const data = ref([])
    const total = ref(0)
    const state = reactive({
      search: "",
      page: 1,
      size: 10
    })
    const isFinish = ref(false)
    const getList = async (isUpdate) => {
      if (!refreshLoading.value) loading.value = true
      const params = {
        ...state,
        page: isUpdate ? 1 : state.page,
        size: isUpdate ? data.value.length : state.size
      }
      const res = await props.getList(params).catch(() => {
        data.value = []
        isFinish.value = true
        loading.value = false
        refreshLoading.value = false
        isEmpty.value = true
      })
      loading.value = false
      refreshLoading.value = false
      if (res?.records) {
        if (res.total > data.value.length) {
          data.value = isUpdate ? res.records : [...data.value, ...res.records]
        }
        total.value = props.paging ? res.total : data.value.length
        if (!isUpdate) state.page += 1

        if (props.paging) isFinish.value = res.total === data.value.length
        else isFinish.value = true

        if (total.value === 0) isEmpty.value = true
        else isEmpty.value = false

        emit("loaded")
      }
    }

    const refresh = () => {
      data.value = []
      state.page = 1
      total.value = 0
      isFinish.value = false
      isEmpty.value = true
      if (!loading.value) {
        refreshLoading.value = true
        getList()
      }
    }

    // 不触发加载动画刷新数据
    const update = () => {
      if (!loading.value) getList(true)
    }

    const refreshLoading = ref(false)
    const pullRefreshProps = computed(() => {
      return {
        class: [`grow-1`, styles.pullRefresh],
        disabled: !props.refresh,
        pullDistance: 100,
        onRefresh: () => {
          isEmpty.value = false
          refresh()
        }
      }
    })
    const listProps = computed(() => {
      return {
        class: styles.listPane,
        finished: isFinish.value,
        loading: loading.value,
        onLoad: getList,
        finishedText: listConfig.value.finishedText,
        emptyText: listConfig.value.emptyText
      }
    })
    const searchProps = computed(() => {
      return {
        class: `h-100pct`,
        placeholder: "请输入关键字",
        showAction: true,
        onSearch: refresh,
        ...props.searchConfig
      }
    })
    const renderSearch = () => {
      const onSearch = () => {
        isEmpty.value = false
        refresh()
      }
      if (props.useSearch) {
        const searchSlots = {
          action: () => (
            <div class={styles.searchBtn} onClick={onSearch}>
              搜索
            </div>
          )
        }
        return (
          <div class={styles.header}>
            <div class={styles.search}>
              <Search
                vModel={state.search}
                {...searchProps.value}
                vSlots={searchSlots}
              />
            </div>

            {slots.filter && slots.filter()}
          </div>
        )
      }
    }
    const renderItems = (record, index) => {
      if (slots.default) return slots.default(record, index)
    }

    const isEmpty = ref(false)
    const renderList = () => {
      if (!isEmpty.value) {
        return (
          <List {...listProps.value}>
            {data.value.map((item, i) => renderItems(item, i))}
          </List>
        )
      }
    }

    onMounted(() => {
      if (isFinish.value) getList()
    })

    const scrollRef = ref()
    const scrollTo = (value) => {
      scrollRef.value.scrollTop = value
    }

    const getScrollTop = () => {
      return scrollRef.value.scrollTop
    }

    expose({
      refresh,
      update,
      scrollTo,
      getScrollTop
    })

    return () => (
      <div class="flex-col base-list">
        {renderSearch()}
        <div class={styles.refreshBody} ref={scrollRef}>
          {slots.top?.()}
          <PullRefresh
            vModel={refreshLoading.value}
            {...pullRefreshProps.value}
          >
            {isEmpty.value && !loading.value && !refreshLoading.value && (
              <Empty imageSize={100} description={listProps.value.emptyText} />
            )}
            {renderList()}
          </PullRefresh>
        </div>
      </div>
    )
  }
})
